import React from 'react';
import { BaseEdge, getStraightPath } from '@xyflow/react';

export const SuccessEdge = ({ id, sourceX, sourceY, targetX, targetY }) => {
  const [edgePath] = getStraightPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  return (
    <BaseEdge
      id={id}
      path={edgePath}
      style={{ stroke: '#10b981', strokeWidth: 2 }}
    />
  );
};

export const FailureEdge = ({ id, sourceX, sourceY, targetX, targetY }) => {
  const [edgePath] = getStraightPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  return (
    <BaseEdge
      id={id}
      path={edgePath}
      style={{ stroke: '#ef4444', strokeWidth: 2 }}
    />
  );
}; 